import type { Theme } from '@mui/material/styles';

/** Shared visual styles for Lely tooltips (MUI `Tooltip` + chart `PositionedTooltip`). */
export const getLelyTooltipSurfaceStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.background.information,
  color: theme.palette.text.light,
  fontFamily: theme.lelyFontFamily.UBUNTU,
  fontSize: theme.typography.md.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: theme.typography.md.lineHeight,
  padding: `${theme.lelySpacing.XS} ${theme.lelySpacing.SM}`,
  borderRadius: theme.lelyBorderRadius.SM,
});

export const getLelyTooltipArrowColor = (theme: Theme) =>
  theme.palette.background.information;

/** MUI arrow uses `1em × 0.71em`; 8px matches Lely Foundation caret (~5.66px square). */
export const LELY_TOOLTIP_ARROW_FONT_SIZE = 8;

/** Foundation caret size for `PositionedTooltip` pseudo-element arrow. */
export const LELY_TOOLTIP_CARET_SIZE = 8;

export const LELY_TOOLTIP_CARET_NUDGE = LELY_TOOLTIP_CARET_SIZE * 0.5;
